var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashcan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 43,
    viewBox: "0 0 35 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.16 11.36H2.83998C1.27998 11.36 0 10.09 0 8.51998V7.56998C0 6.00998 1.26998 4.72998 2.83998 4.72998H32.16C33.72 4.72998 35 5.99998 35 7.56998V8.51998C35 10.08 33.73 11.36 32.16 11.36ZM2.83998 6.62998C2.31998 6.62998 1.89 7.04998 1.89 7.57998V8.52998C1.89 9.04998 2.30998 9.47998 2.83998 9.47998H32.16C32.68 9.47998 33.11 9.05998 33.11 8.52998V7.57998C33.11 7.05998 32.69 6.62998 32.16 6.62998H2.83998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.85 42.57H7.13998C5.02998 42.57 3.29999 40.85 3.29999 38.73V10.4C3.29999 9.87995 3.71997 9.44995 4.24997 9.44995H30.74C31.26 9.44995 31.69 9.86995 31.69 10.4V38.73C31.69 40.84 29.97 42.57 27.85 42.57ZM5.19998 11.35V38.73C5.19998 39.8 6.06998 40.6699 7.13998 40.6699H27.85C28.92 40.6699 29.79 39.8 29.79 38.73V11.35H5.19998Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.23 6.63H12.77C12.25 6.63 11.82 6.21 11.82 5.68V2.84C11.82 1.28 13.09 0 14.66 0H20.34C21.9 0 23.18 1.27 23.18 2.84V5.68C23.18 6.2 22.76 6.63 22.23 6.63ZM13.72 4.74H21.29V2.85C21.29 2.33 20.87 1.9 20.34 1.9H14.66C14.14 1.9 13.71 2.32 13.71 2.85V4.74H13.72Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 36.4201C16.98 36.4201 16.55 36.0001 16.55 35.4701V16.5601C16.55 16.0401 16.97 15.6101 17.5 15.6101C18.03 15.6101 18.45 16.0301 18.45 16.5601V35.4701C18.45 35.9901 18.03 36.4201 17.5 36.4201Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.89 36.4201C23.37 36.4201 22.9399 36.0001 22.9399 35.4701V16.5601C22.9399 16.0401 23.36 15.6101 23.89 15.6101C24.42 15.6101 24.8399 16.0301 24.8399 16.5601V35.4701C24.8399 35.9901 24.42 36.4201 23.89 36.4201Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.12 36.4201C10.6 36.4201 10.17 36.0001 10.17 35.4701V16.5601C10.17 16.0401 10.59 15.6101 11.12 15.6101C11.65 15.6101 12.07 16.0301 12.07 16.5601V35.4701C12.07 35.9901 11.65 36.4201 11.12 36.4201Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashcan);
export default __webpack_public_path__ + "static/media/trashcan.6d8b63b0713b8f6fb46d3d1c5476b9a7.svg";
export { ForwardRef as ReactComponent };